import axios from "axios";

import { getConfig } from "merchant-portal-frontend/src/config";
import { HTTPClient } from "merchant-portal-frontend/src/model/api/http";

const DEFAULT_TIMEOUT = (() => {
	const fromConfig = getConfig("defaultcalltimeout");
	return fromConfig && typeof fromConfig === "number" && fromConfig > 0 ? fromConfig : 30000;
})();

export function makeBreadApiClient(): HTTPClient {
	return {
		async doFetch({
			url,
			method,
			headers,
			payload,
			queryParams,
			timeout = DEFAULT_TIMEOUT,
			isAuthenticated = true,
			abortController,
		}) {
			const {
				data,
				headers: responseHeaders,
				status,
			} = await axios({
				url,
				method,
				isAuthenticated,
				headers: {
					"Content-Type": "application/json",
					...headers,
				},
				...(payload && { data: payload }),
				...(queryParams && { params: queryParams }),
				...(abortController && { signal: abortController.signal }),
				timeout,
			});
			return { data, headers: responseHeaders, status };
		},

		fetch({
			url,
			payload,
			queryParams,
			headers,
			method = "GET",
			timeout = DEFAULT_TIMEOUT,
			isAuthenticated,
			abortController,
		}) {
			const doFetchParams = {
				url,
				method,
				headers,
				queryParams,
				payload,
				timeout,
				isAuthenticated,
				abortController,
			};
			return this.doFetch(doFetchParams);
		},

		post(params) {
			return this.fetch({ method: "POST", ...params });
		},

		patch(params) {
			return this.fetch({ method: "PATCH", ...params });
		},

		put(params) {
			return this.fetch({ method: "PUT", ...params });
		},

		delete(params) {
			return this.fetch({ method: "DELETE", ...params });
		},
	};
}
